import { SignupCoveragePreference } from '@jerry-serverless/types';

import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

export const CustomCoveragesStep: Step = {
  id: 'customcoverages',
  pathname: '/customcoverages',
  canShow: (appData: AppData) => appData.signupParams?.coveragePreference === SignupCoveragePreference.Customize,
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Coverage,
};
